import {
  PRESALE_CONTRACT_ADDRESS,
  USDT_CONTRACT_ADDRESS,
} from "../../../constants";
import { usdtAbi } from "../../../abis/usdtAbi";
import { useReadContract, useAccount } from "wagmi";

export function useAllowance() {
  const userAccount = useAccount();
  const { data, error, isLoading, refetch } = useReadContract({
    address: USDT_CONTRACT_ADDRESS,
    abi: usdtAbi,
    functionName: "allowance",
    args: [
      userAccount.address as `0x${string}`,
      PRESALE_CONTRACT_ADDRESS as `0x${string}`,
    ],
  });


  if (isLoading) return null;

  if (error) {
    console.log(error);
    return null;
  }

  if (data === undefined) return null;

  const allowance = Number((data * BigInt(100)) / BigInt(10 ** 18)) / 100 ;

  return { allowance, refetchUSDTAllowance: refetch, isLoading };
}
